module.exports = __webpack_public_path__ + "static/Lato-Medium-0996d39c4cf5d223a14559dfa37047fd.woff2";